type Answer = {
  text?: string
  link?: string
}

type Props = {
  answer: Answer | Answer[]
}

export function FileAnswer({ answer }: Props) {
  if (!Array.isArray(answer) && answer.link) {
    return (
      <div className="flex items-center gap-2">
        <img className="size-10 rounded object-cover" src={answer.link} alt={answer.text || ''} />
      </div>
    )
  }

  return null
}
